module.exports = __webpack_public_path__ + "media/images/team/karen_francis-1c0c92330d2a1b6fdc8fa671b823fd42.png";